import { defa }   from 'defa-object';
import AlarmGroup from 'scripts/defa/alarm-groups/model-alarm-group';

/**
 * defa.collections.AlarmGroups
 * A Collection of AlarmGroup models.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );

const api         = {
	alarmGroups: defa.vars.apiHost + '/alarmgroups',
};
const AlarmGroups = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	url  : api.alarmGroups,
	model: AlarmGroup,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Parses incoming data before setting the variables on the collections.
	 * @param  {Object} response  The response object from a save or set function, including insuranceCompanies and
	 *     alarmCentrals.
	 * @return {Object}           The parsed response object, alarmGroups-data only.
	 */
	parse: function ( response ) {
		
		if ( response.insuranceCompanies ) {
			channel.request( 'insuranceCompanies' ).add( response.insuranceCompanies, { merge: true } );
		}
		
		if ( response.alarmCentrals ) {
			channel.request( 'alarmCentrals' ).add( response.alarmCentrals, { merge: true } );
		}
		
		if ( response.alarmGroups ) {
			response = response.alarmGroups;
		}
		
		return response;
	},
	
	/**
	 * Returns a new AlarmGroups collection filtered by an array of ids.
	 * @param  {array}                ids  An array of ids to filter the collection by.
	 * @return {AlarmGroups}          The filtered AlarmGroupCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( alarmGroup ) {
			return _.contains( ids, alarmGroup.get( 'id' ) );
		} );
		
		return new AlarmGroups( array );
	},
	
} );

export default AlarmGroups;